import {
  ChartDataSets,
  ChartOptions,
  ChartScales,
  ChartXAxe,
  ChartYAxe,
  TickOptions,
  TimeScale,
} from "chart.js";
import React from "react";
import { Line } from "react-chartjs-2";
import { baseOption, colors } from "../../utils";

interface LineChartOptions {
  data: any[];
}

const lineOptions: ChartOptions = {
  scales: {
    xAxes: [
      {
        stacked: true,
        position: "bottom",
        type: "time",
        distribution: "linear",
        time: {
          unitStepSize: 3,
          minUnit: "month",
          unit: "month",
          tooltipFormat: "MMM YYYY",
        } as TimeScale,
        scaleLabel: {
          display: true,
          labelString: "Time",
          fontColor: "#1d344e",
        },
      },
    ] as ChartXAxe[],
    yAxes: [
      {
        position: "left",
        ticks: {
          beginAtZero: true,
        } as TickOptions,
        scaleLabel: {
          display: true,
          labelString: "Total number",
          fontColor: "#1d344e",
        },
      },
    ] as ChartYAxe[],
  } as ChartScales,
  legend: {
    display: true,
    position: "right",
    labels: {
      padding: 20,
    },
  },
  maintainAspectRatio: false,
  plugins: {
    datalabels: {
      display: false,
    },
  },
};

export const LineChart: React.FC<LineChartOptions> = (props) => {
  const { data } = props;

  return (
    <Line
      data={{
        datasets: data.map((row, index) => {
          return {
            ...row,
            ...baseOption(colors[index]),
          } as ChartDataSets;
        }),
      }}
      options={lineOptions}
    />
  );
};
